"use client"
/* */
import { useRef, useEffect } from 'react';

const useOnChange = (value, callback, dependencies = []) => {
  const oldValue = useRef(value);
  useEffect(() => {
    if (oldValue.current !== value) {
      callback();
    }
    oldValue.current = value;
  }, [value, callback, ...dependencies]);
};

export { useOnChange };
//# sourceMappingURL=useOnChange.mjs.map
